export const MODES = {
    INDEPENDENT: 'INDEPENDENT',
    EXISTING_SEARCH: 'EXISTING_SEARCH',
    NEW_COMPANY: 'NEW_COMPANY',
    NEW_MEMBER: 'NEW_MEMBER',
    READ_ONLY: 'READ_ONLY',
};

export const ACTIVE = 'ACTIVE';
export const DISABLED = 'DISABLED';
export const HIDDEN = 'HIDDEN';

export const initializeState = ({ isIndependent, isNewMember, disableCompanySelection, isEventRegistration }) => {
    let mode = MODES.EXISTING_SEARCH;
    if (disableCompanySelection) {
        mode = MODES.READ_ONLY;
    } else if (isIndependent) {
        mode = MODES.INDEPENDENT;
    }
    return {
        mode,
        newMember: isNewMember,
        independent: isIndependent,
        disableCompanySelection,
        isEventRegistration,
        fieldStates: updateFieldStates(mode, { disableCompanySelection, isEventRegistration, isNewMember }),
    };
};

const updateFieldStates = (newMode, state) => {
    let newFieldStates;
    const { disableCompanySelection, isNewMember } = state;
    switch (newMode) {
        case MODES.INDEPENDENT:
            newFieldStates = {
                newCompanyFields: HIDDEN,
                modeButton: DISABLED,
                independentCheckbox: ACTIVE,
                jobTitle: HIDDEN,
                responsibility: HIDDEN,
                memberFields: ACTIVE,
                companyName: DISABLED,
            };
            break;
        case MODES.EXISTING_SEARCH:
            newFieldStates = {
                newCompanyFields: HIDDEN,
                modeButton: ACTIVE,
                independentCheckbox: ACTIVE,
                jobTitle: ACTIVE,
                responsibility: ACTIVE,
                memberFields: ACTIVE,
                companyName: disableCompanySelection ? DISABLED : ACTIVE,
            };
            break;
        case MODES.NEW_COMPANY:
            newFieldStates = {
                newCompanyFields: ACTIVE,
                modeButton: ACTIVE,
                independentCheckbox: ACTIVE,
                jobTitle: HIDDEN,
                responsibility: ACTIVE,
                memberFields: ACTIVE,
                companyName: disableCompanySelection ? DISABLED : ACTIVE,
            };
            break;
        case MODES.NEW_MEMBER:
            newFieldStates = {
                memberFields: HIDDEN,
                newCompanyFields: HIDDEN,
                modeButton: HIDDEN,
                independentCheckbox: HIDDEN,
                jobTitle: ACTIVE,
                responsibility: ACTIVE,
                companyName: DISABLED,
            };
            break;
        case MODES.READ_ONLY:
            newFieldStates = {
                newCompanyFields: HIDDEN,
                modeButton: DISABLED,
                independentCheckbox: DISABLED,
                jobTitle: ACTIVE,
                responsibility: ACTIVE,
                memberFields: ACTIVE,
                companyName: DISABLED,
            };
            break;
        default:
            throw new Error(`No case for ${newMode}`);
    }

    return { ...state.fieldStates, ...newFieldStates };
};

const companyFieldsReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case 'TOGGLE_INDEPENDENT': {
            const newMode = state.independent ? MODES.EXISTING_SEARCH : MODES.INDEPENDENT;
            return {
                ...state,
                ...{
                    mode: newMode,
                    independent: !state.independent,
                    fieldStates: updateFieldStates(newMode, state),
                },
            };
        }
        case 'SET_MODE': {
            const newMode = payload;
            return {
                ...state,
                ...{
                    mode: newMode,
                    independent: false,
                    fieldStates: updateFieldStates(newMode, state),
                },
            };
        }
        case 'CLEAR_SEARCH':
            return {
                ...state,
                ...{
                    mode: MODES.EXISTING_SEARCH,
                },
            };
        default:
            throw new Error(`No case for type ${type} found in shopReducer.`);
    }
};

export default companyFieldsReducer;
